import { Hook } from '../../../types';
import { InceptHeader } from '../../constants/InceptHeader';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';

export const getDocumentHooks = async (
  constructGet: ConstructGet,
  documentId: string,
  definitionName: string,
  statusDefinitionName?: string,
): Promise<NonPaginatedResponse<Hook[]> | undefined> =>
  constructGet(
    statusDefinitionName
      ? `${DOCUMENTS_BASE_PATH}/${documentId}/hooks/${statusDefinitionName}`
      : `${DOCUMENTS_BASE_PATH}/${documentId}/hooks`,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
  );
